/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { FaCoins } from 'react-icons/fa';
import { styled } from '@mui/material/styles';

// استدعاء دوال الإشعارات
import { 
  sendFileDownloadedNotification, 
  sendInsufficientBalanceNotification 
} from '../../notifications';

// -------------------------------------------
const DownloadButton = styled('button')({
  backgroundColor: '#13aa52',
  border: '1px solid #13aa52',
  borderRadius: '4px',
  boxShadow: 'rgba(0, 0, 0, .1) 0 2px 4px 0',
  boxSizing: 'border-box',
  color: '#fff',
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: '400',
  outline: 'none',
  padding: '7px 25px',
  textAlign: 'center',
  transform: 'translateY(0)',
  transition: 'transform 150ms, box-shadow 150ms',
  userSelect: 'none',
  touchaction: 'manipulation',
  '&:hover': {
    boxShadow: 'rgba(0, 0, 0, .15) 0 3px 9px 0',
    transform: 'translateY(-2px)',
  },
  '&:focus': {
    boxShadow: 'rgba(0, 0, 0, .15) 0 3px 9px 0',
    transform: 'translateY(-2px)',
  },
});
// -------------------------------------------

export default function PurchaseConfirmationModal({ handleClose, show, fileId, fileTitle, filePrice, userCoins , userverified }) {
  const Navigate = useNavigate();
  const [balanceColor, setbalanceColor] = useState('yellowgreen');
  const [downloadButton, setDownloadButton] = useState();
  const [balanceReady, setBalanceReady] = useState(false); // ✅ حالة تحميل الرصيد

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const config = {
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${userInfo?.access}`,
    },
  };

  // ------------تحميل الملف -----------
  const getFile = async () => {
    CheckBalance();
    try {
      const data = await axios.get(`${process.env.REACT_APP_API_KEY}/api/v1/files/download-file/${fileId}`, config);
      const fileSource = data.data.map((file) => file.source ? `${process.env.REACT_APP_API_KEY}${file.source}` : file.file_url);

      setTimeout(() => {
        window.open(`${fileSource}`);
      }, 500);

      // ✅ إرسال إشعار بعد أول عملية تحميل فقط
      if (!localStorage.getItem("firstDownloadSent")) {
        await sendFileDownloadedNotification(userInfo, { title: fileTitle });
        localStorage.setItem("firstDownloadSent", "true");
      }

    } catch (err) {
      console.error(err);
    }
  };

  // --------التحقق من الرصيد -----------------
  const CheckBalance = () => {
    if (filePrice <= userCoins) {
      setDownloadButton(true);
      setbalanceColor('green');
    } else {
      setDownloadButton(false);
      setbalanceColor('red');

      // ✅ إرسال إشعار مرة واحدة فقط عند أول فتح للـ Modal مع رصيد غير كافي
      if (!localStorage.getItem("insufficientBalanceNotified")) {
        sendInsufficientBalanceNotification(userInfo, { title: fileTitle });
        localStorage.setItem("insufficientBalanceNotified", "true");
      }
    }
  };

  // ----------------------------------------
  const balanceAfter = userCoins - filePrice;
  // ----------------------------------------

  // ✅ نتأكد إن الرصيد اتحدث قبل تشغيل CheckBalance
  useEffect(() => {
    if (userCoins !== undefined && userCoins !== null) {
      setBalanceReady(true);
    }
  }, [userCoins]);

  // ✅ تشغيل CheckBalance فقط لما الـ Modal يتفتح والرصيد جاهز
  useEffect(() => {
    if (show && balanceReady) {
      CheckBalance();
    }
  }, [show, balanceReady]);

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title sx={{ fontWeight: 'bold' }}>Purchase Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography variant="h6">Are You Sure You Want To Download</Typography>
          <Typography variant="body1">{fileTitle}</Typography>
          <Typography variant="body1">
            This file will cost you <span style={{ color: 'green', fontWeight: 'bold' }}> {filePrice}</span>{' '}
            <FaCoins style={{ color: 'green' }} />
            <br />
            <Typography>
              Your current balance
              <span style={{ color: balanceColor, fontWeight: 'bold' }}> {userCoins}</span>{' '}
              <FaCoins style={{ color: balanceColor }} />{' '}
            </Typography>
          </Typography>
          {downloadButton ? (
            <Typography variant="body1">
              Balance After Purchasing <span style={{ color: 'green', fontWeight: 'bold' }}>{balanceAfter}</span>{' '}
              <FaCoins style={{ color: 'yellowgreen' }} />
            </Typography>
          ) : (
            ''
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {downloadButton ? (
            <DownloadButton onClick={() => { getFile(); handleClose(); }} >Download</DownloadButton>
          ) : (
            <DownloadButton onClick={() => Navigate('/dashboard/recharge')}>Recharge</DownloadButton>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
